import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { eligible } from "@/components/ServiceAssign";

export function ReplaceSignup({ svc, signup, onDone, onCancel }) {
  const [people, setPeople] = useState([]);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/volunteers").then(({ data }) => setPeople(data)).catch(() => {});
  }, []);

  const assigned = new Set((svc.signups || []).map((s) => s.user_id));
  const options = people.filter((p) => !assigned.has(p.id) && eligible(p, signup.slot, svc, signup.vehicle_id));

  const replace = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/services/${svc.id}/replace`, { old_user_id: signup.user_id, new_user_id: pick });
      toast.success(`${signup.name} sostituito`);
      onDone(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 rounded-lg bg-muted/60 p-2" data-testid={`replace-box-${signup.user_id}`}>
      <span className="text-xs font-medium">Sostituisci con:</span>
      <Select value={pick} onValueChange={setPick}>
        <SelectTrigger className="h-8 text-xs flex-1 min-w-[160px]" data-testid={`replace-select-${signup.user_id}`}>
          <SelectValue placeholder={options.length ? "Scegli…" : "Nessuno con le qualifiche richieste"} />
        </SelectTrigger>
        <SelectContent>{options.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
      </Select>
      <Button size="sm" data-testid={`replace-confirm-${signup.user_id}`} disabled={!pick || busy} onClick={replace} className="rounded-full h-8">Sostituisci</Button>
      <Button size="sm" variant="ghost" onClick={onCancel} className="h-8">Annulla</Button>
    </div>
  );
}
